import { render } from "./RelacionOpcionPerfil.vue?vue&type=template&id=b9b44f54"
import script from "./RelacionOpcionPerfil.vue?vue&type=script&lang=js"
export * from "./RelacionOpcionPerfil.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__